// extracted by mini-css-extract-plugin
export var checkbox = "_79-0";
export var circle = "_79-3";
export var horizontalContainer = "_79-7";
export var sm = "_79-5";
export var switch0 = "_79-2";
export var switchDisabled = "_79-8";
export var switchEnabled = "_79-1";
export var textSwitchContainer = "_79-9";
export var textSwitchOption = "_79-a";
export var textSwitchOptionSelected = "_79-b";
export var verticalContainer = "_79-6";
export var xs = "_79-4";